import { compose, pure } from "recompose";

import Cleave from "cleave.js/react";
import Datetime from "react-datetime";
import React from "react";
import { injectIntl } from "react-intl";
import moment from "moment";

class CustomDatetime extends React.Component {
  constructor(props) {
    super();
    this.state = {
      dateCleave: null,
      locale: props.locale,
      value: (props.defaultValue && props.defaultValue) || ""
    };
  }

  // static getDerivedStateFromProps = async (props, state) => {
  //   console.log("20 - getDerivedStateFromProps", props, state);
  //   // if (props.forcedValue) {
  //     state.value = props.forcedValue || undefined;
  //   // }
  // }


  onDateCleaveInit = cleave => {
    this.setState({ dateCleave: cleave });
  };

  render() {
    const { locale } = this.props;
    const datePattern =
      this.state.locale && this.state.locale.includes("en")
        ? ["m", "d", "Y"]
        : ["d", "m", "Y"] || ["d", "m", "Y"];

    const local = !!locale ? locale : "fr";

    if (local !== "en") {
      // en is enabled by default already
      require(`moment/locale/${local}`);
      moment.locale(local);
    }

    // console.log("46 - CustomDatetime.render", this.props, this.state, moment.locale());
    return (
      <Datetime
        renderInput={(props, openCalendar, closeCalendar) => {
          return (
            <Cleave
              {...props}
              defaultValue={this.state.value}
              placeholder={this.props.intl.formatMessage({
                id: "ids_enterADate"
              })}
              locale={local}
              options={{
                date: true,
                datePattern
              }}
              onKeyDown={e => {
                if (e.keyCode === 13 || e.keyCode === 9) {
                  // return key
                  if (e.target) {
                    const value = e.target.value;
                    const d = moment(value, "L", locale);
                    if (d._isValid) {
                      if (this.props.onBlur)
                        this.props.onBlur(d);
                      else if (this.props.onChange)
                        this.props.onChange(d);
                    }
                  }
                }
              }}
              onInit={this.onDateCleaveInit}
              onBlur={e => {
                // const value = e.target.value;
                // const d = moment(value, "L", locale);
                // this.props.onBlur(d);
              }}
            />
          );
        }}
        closeOnSelect={true}
        closeOnTab={true}
        timeFormat={false}
        dateFormat={true}
        strictParsing={false}
        {...this.props}
      />
    );
  }
}

export default compose(
  injectIntl,
  pure
)(CustomDatetime);
